export const space = ({ top, right, bottom, left }) => ({
    overflow: 'hidden',
    position: 'relative',
    paddingTop: top,
    paddingRight: right,
    paddingBottom: bottom,
    paddingLeft: left,
});
